import type { IconData } from '@stacksjs/iconify-core'

export const shoppingHelpInformation: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M9.5 4a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0M9 6.5H5v2h2v2H5v2h6v-2H9z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingHelpInformation
